// Rows: `{ id, title, question, scoreType, disabled }`. Ids fall back to the title so a
// consumer passing bare criteria items still gets stable keys.
export const normalizeRows = (rows = []) =>
    (Array.isArray(rows) ? rows : []).map((row, index) => ({
        ...row,
        id: String(row.id ?? row.attribute ?? row.title ?? index),
        title: row.title ?? row.attribute ?? '',
        question: row.question ?? '',
        scoreType: row.scoreType ?? row.score_type ?? '',
        disabled: Boolean(row.disabled),
    }));

// Options: `{ id, text }` (select2 shape) or `{ value, label }`; SelectDropdown accepts both.
export const toSelectOptions = (options = []) =>
    (Array.isArray(options) ? options : []).map((option) =>
        typeof option === 'object'
            ? option
            : { id: option, text: String(option) },
    );
